import { Component, Input } from '@angular/core';

@Component({
    selector: 'pr-panel-header',
    templateUrl: './pr-panel-header.component.html',
    styleUrls: ['./pr-panel-header.component.scss'],
    standalone: false
})
export class PrPanelHeaderComponent {
  @Input() clazz: string;
  @Input() title: string;
  @Input() titleClass: string;
  @Input() icon: string;
  @Input() img: string;

  constructor() {}
}
